module.exports = __webpack_public_path__ + "img/IAA.f12ff150.svg";